import React from 'react'

import {usePaymentCardAdd} from './PaymentCardAdd.hooks'
import type {Props} from './PaymentCardAdd.types'
import {PaymentCardAddButton} from './PaymentCardAddButton.mobile'
import {TrustModal} from './TrustModal.mobile'

export function PaymentCardAdd(props: Props): React.ReactElement<Props> {
  const {disabled, fetchCardBoundContext} = props
  const {opened, openHandler, successHandler, closeHandler} = usePaymentCardAdd(props)

  return (
    <>
      <PaymentCardAddButton disabled={disabled} onPress={disabled ? undefined : openHandler} />
      {opened && <TrustModal fetchCardBoundContext={fetchCardBoundContext} onClose={closeHandler} onSuccess={successHandler} />}
    </>
  )
}
